import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import Layout from './components/Layout'
import PublicLayout from './components/PublicLayout'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Portfolio from './pages/Portfolio'
import Health from './pages/Health'
import Rebalance from './pages/Rebalance'
import Streaming from './pages/Streaming'
import Recommendation from './pages/Recommendation'
import Signals from './pages/Signals'
import Intraday from './pages/Intraday'
import Prompt from './pages/Prompt'
import Reports from './pages/Reports'
import Settings from './pages/Settings'
import MutualFunds from './pages/MutualFunds'
import About from './pages/public/About'
import Features from './pages/public/Features'
import Contact from './pages/public/Contact'
import FAQ from './pages/public/FAQ'
import Privacy from './pages/public/Privacy'
import Terms from './pages/public/Terms'
import LoadingSpinner from './components/LoadingSpinner'
import { StreamingProvider } from './contexts/StreamingContext';

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="large" />
      </div>
    )
  }

  return (
    <Routes>
      {/* Public info pages — available to everyone, logged in or not */}
      <Route element={<PublicLayout />}>
        <Route path="/about"    element={<About />} />
        <Route path="/features" element={<Features />} />
        <Route path="/contact"  element={<Contact />} />
        <Route path="/faq"      element={<FAQ />} />
        <Route path="/privacy"  element={<Privacy />} />
        <Route path="/terms"    element={<Terms />} />
      </Route>

      {!user ? (
        <>
          {/* Auth screens share the public shell (top bar + footer) */}
          <Route element={<PublicLayout />}>
            <Route path="/login"    element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      ) : (
        <Route path="/" element={
          <StreamingProvider>
            <Layout />
          </StreamingProvider>
        }>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="health" element={<Health />} />
          <Route path="rebalance" element={<Rebalance />} />
          <Route path="streaming" element={<Streaming />} />
          <Route path="recommendation" element={<Recommendation />} />
          <Route path="signals" element={<Signals />} />
          <Route path="intraday" element={<Intraday />} />
          <Route path="prompt" element={<Prompt />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Settings />} />
          <Route path="mutual-funds" element={<MutualFunds />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      )}
    </Routes>
  )
}

export default App
